export enum SubscriptionStatusEnum {
  active = 'active',
  cancelled = 'cancelled',
  completed = 'completed',
}

export const subscriptionStatusLocoKeys: Record<SubscriptionStatusEnum, string> = {
  [SubscriptionStatusEnum.active]: 'global.active',
  [SubscriptionStatusEnum.cancelled]: 'global.cancelled',
  [SubscriptionStatusEnum.completed]: 'global.completed',
}
